import firebase from "firebase";

// Get it from the firebase console.
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
    apiKey: "AIzaSyBd310dDxMq1c9G5Bv5TScwYR6w3l08sE8",
    authDomain: "craterd-cd6c8.firebaseapp.com",
    databaseURL: "https://craterd-cd6c8.firebaseio.com",
    projectId: "craterd-cd6c8",
    storageBucket: "craterd-cd6c8.appspot.com",
    messagingSenderId: "842146582073",
    appId: "1:842146582073:web:f37e193e0c45acc1cb07e8",
    measurementId: "G-5XD4FDVHC1"
};

// Get it from the Stripe dev console.
export const stripeKeys = {
    public: "pk_test_51HVMZ2CpqjUxOVQbM3IF95TEUkOUTQoQtM9m99W3bKzgiAFVnYQeEaK6QMUSWy0szJk8ajX9Eod7UEoVuaIZbmz400yqZLd3sr",
};

const firebaseApp = firebase.initializeApp(firebaseConfig);

const db = firebaseApp.firestore();
const authCraterd = firebase.auth();

export { db, authCraterd };